<template>
  <CadastroVaquejada
    :edit-mode="true"
    :vaquejada="vaquejada"
  />
</template>

<script lang="ts">
  import CadastroVaquejada from '@/pages/CadastroVaquejada.vue'
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'EditarVaquejada',
    components: { CadastroVaquejada },
    data: () => ({
      vaquejada: {},
    }),
    methods: {
      async list() {
        const response = await this.axios.get(`vaquejadas/${this.$route.params.id}?includeCity=true`);
        this.vaquejada = response.data.vaquejada;
      }
    },
    async created() {
      await this.list();
    }
  });
</script>

<style scoped>

</style>
